import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, ChangeDetectorRef, OnInit } from '@angular/core';
import { ISubjectsAppearance } from "@ispm/therapies/interfaces/subject.interface";
import { select, Store } from '@ngrx/store';
import { INotificationState } from "@ispm/dashboard/notification/store/notification.reducer";
import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { getNotification } from "@ispm/dashboard/notification/store/notification.selectors";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'ispm-subject-list-row',
  templateUrl: './subject-list-row.component.html',
  styleUrls: ['./subject-list-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectListRowComponent implements OnInit {
  private _value: any;

  @Input()
  public set value(value: any) {
    this.ellipsisApplied = false;
    this._value = value;
  }

  public get value() {
    return this._value;
  }

  @Input()
  public editVisible: boolean;

  @Input()
  public editable: boolean;

  @Input()
  public selected: boolean;

  @Input()
  public subjectsAppearance: ISubjectsAppearance;

  @Input()
  subject: ISubjectsAppearance['subjects'][keyof ISubjectsAppearance['subjects']];

  @Input()
  public hideCheckBox: boolean;

  @Input()
  public fields: any;

  @Input()
  public formId: string;

  @Output()
  public editTherapyClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public changeIncludeIn: EventEmitter<{ includeIn: 'report' | 'MI', state: boolean}> = new EventEmitter();

  @Output()
  public isTherapyChecked: EventEmitter<boolean> = new EventEmitter();

  public ellipsisApplied: boolean = null;

  public notificationStore: Store<INotificationState>;

  public previewMode$: Observable<boolean>;

  constructor(
    private _cd: ChangeDetectorRef,
    store: Store<IgenomicsState>
  ) {
    this.notificationStore = store.select('notification') as any;
  }

  trackByIndex(index) {
    return index;
  }

  trackByField(index, field) {
    return [field.cssClasses, field.path].join(('_'));
  }

  editTherapy(config: any) {
    this.editTherapyClicked.emit(config);
  }

  includeInChange(event: { includeIn: 'report' | 'MI', state: boolean}) {
    this.changeIncludeIn.emit(event);
  }

  updateApplyEllipsis(apply: boolean) {
    this.ellipsisApplied = apply;
  }

  getUpdateApplyEllipsisCallback(apply) {
    return () => this.updateApplyEllipsis(apply);
  }

  updateTherapyChecked(state: boolean) {
    this.isTherapyChecked.emit(state);
  }

  isCheckBoxDisabled() {
    return !this.editable;
  }

  ngOnInit() {
    this.previewMode$ = this.notificationStore.pipe(
      select(getNotification),
      map(notificationConfig => notificationConfig?.type === 'warning')
    );
  }
}
